import React from 'react'
import { Text } from '@moonpig/launchpad-components'
import {
  StyledAddToBasketAlert,
  StyledAddToBasketAlertContainer,
} from './styled'

export const AddToBasketAlert = ({
  message,
  variant,
}: {
  message: string
  variant: 'success' | 'error'
}) => {
  return (
    <StyledAddToBasketAlertContainer>
      <StyledAddToBasketAlert variant={variant}>
        <Text typography="typeDesktopDisplay06">{message}</Text>
      </StyledAddToBasketAlert>
    </StyledAddToBasketAlertContainer>
  )
}
